import { BasicStatusTranslationService } from 'src/app/shared/translations';
import { Attribute } from '../club/attributes';

/**
 * Blueprint for the Attribute entity.
 */
export class CustomerAttribute {
  public id: number;
  public attribute: Attribute;
  public customer: string;

  public constructor(attribute: any, private translations: BasicStatusTranslationService) {
    this.id = attribute.id;
    this.attribute = new Attribute(attribute.attribute, this.translations);
    this.customer = attribute.customer;
  }
}
